import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'

export const useUpdateProductStatusMutation = () => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: updateProductStatusMutation } = useMutation({
		mutationFn: ({ id, published }: { id: number; published: boolean }) => {
			return axiosPrivate.patch(apiRoutes.product(id.toString()), {
				published
			})
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.products.all })
			useToast({
				type: 'success',
				message: t('Status updated')
			})()
		},
		onError: (err: any) => {
			useToast({
				type: 'error',
				message: err.response?.data?.non_field_errors?.[0] ?? t('Something went wrong')
			})()
		}
	})

	return {
		updateProductStatusMutation
	}
}
